import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  promoTexts: [],
  announcementMarquees: [],
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setHomePromoData: (state, action) => {
      state.promoTexts = action.payload?.promoTexts || [];
      state.announcementMarquees = action.payload?.announcementMarquees || [];
    },
  },
});

export const { setHomePromoData } = homeSlice.actions;
export default homeSlice.reducer;
